// Patamora v26: mejoras de la auditoría CRO (28-oct). Se carga desde sections/pm-globals.liquid.
// Datos: <script id="pm-data"> (snippets/pm-data.liquid).

const data = (() => {
  try { return JSON.parse(document.getElementById('pm-data').textContent); } catch (e) { return null; }
})();

const eur = (c) => (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
const handleOf = (a) => ((a && a.getAttribute('href')) || '').match(/\/products\/([^/?#]+)/)?.[1];
const here = handleOf({ getAttribute: () => location.pathname });
const short = (t) => t.split(' con ')[0].replace(/ para (perros|gatos)$/i, '');
const el = (tag, cls, text) => {
  const n = document.createElement(tag);
  n.className = cls;
  if (text) n.textContent = text;
  return n;
};
const cartCount = async () => {
  try { return (await (await fetch('/cart.js')).json()).item_count; } catch (e) { return 0; }
};
const GUIDE_PACKS = ['pack-petardos', 'pack-calma-ruidos'];

// --- Portada: texto de confianza bajo el botón (el plazo exacto sigue en la cinta, la ficha, el carrito y el pago) ---
const heroTrust = () => {
  const ul = document.querySelector('.pm-hero__trust:not([data-pm-t])');
  if (!ul) return;
  ul.dataset.pmT = '1';
  ul.replaceChildren(el('li', '', 'Envío con seguimiento · 14 días para probarlo · IVA incluido (sin aduanas)'));
};

// --- Packs: qué se ahorra frente a comprar las piezas por separado (precio actual de cada pieza) ---
// shortcut: pm-data solo trae el precio de la variante más barata; si un pack lleva otra variante, su suma va aquí (céntimos). Cambiar si cambian los precios.
const PACK_SEP = { 'pack-gato-calentito': 4290, 'pack-sofa-limpio': 4885 };
const packInfo = (handle) => {
  const p = data && data.p[handle];
  if (!p || !p.k) return null;
  let sep = 0;
  const names = [];
  for (const k of p.k) {
    const q = data.p[k];
    if (!q) return null;
    sep += q.c;
    names.push(short(q.t));
  }
  sep = PACK_SEP[handle] || sep;
  if (GUIDE_PACKS.includes(handle)) names.push('Guía PDF');
  return sep > p.c ? { sep, save: sep - p.c, names, n: p.k.length } : null;
};

const was = (i, cls) => {
  const box = el('span', cls, 'Por separado ');
  box.append(el('s', '', eur(i.sep)));
  return box;
};

const decoratePacks = () => {
  // Tarjetas de producto de Horizon (colecciones, catálogo, carruseles)
  document.querySelectorAll('product-card:not([data-pm-s])').forEach((card) => {
    card.dataset.pmS = '1';
    const i = packInfo(handleOf(card.querySelector('a.product-card__link')));
    if (!i) return;
    const gallery = card.querySelector('.card-gallery');
    if (gallery) gallery.append(el('span', 'pm-pill', `Pack ahorro · ${i.n} productos`));
    const content = card.querySelector('.product-card__content');
    const price = card.querySelector('product-price');
    if (price) price.append(el('s', 'pm-cardwas', eur(i.sep)));
    if (content) {
      const box = el('p', 'pm-cardsave');
      box.append(el('span', 'pm-cardsave__in', 'Incluye: ' + i.names.join(' + ')));
      const line = was(i, '');
      line.append(' · ');
      line.append(el('strong', '', `Ahorras ${eur(i.save)}`));
      box.append(line);
      content.append(box);
    }
  });

  // Packs de la portada y de las fichas (sections/pm-packs)
  document.querySelectorAll('.pm-pack:not([data-pm-s])').forEach((pack) => {
    pack.dataset.pmS = '1';
    const handle = handleOf(pack.querySelector('.pm-pack__title a'));

    // El quitapelos suelto repetía su nombre como único punto de la lista: mejor dos ventajas.
    const list = pack.querySelector('.pm-pack__list');
    if (handle === 'quitapelos-reutilizable' && list && list.children.length === 1) {
      list.replaceChildren(...['Rodillo con depósito fácil de vaciar', 'Sin recambios adhesivos ni pilas'].map((t) => el('li', '', t)));
    }

    if (pack.querySelector('.pm-chip--coral')) return;
    const i = packInfo(handle);
    if (!i) return;
    const price = pack.querySelector('.pm-pack__price');
    if (price) price.append(was(i, 'pm-pack__was'));
    const perks = pack.querySelector('.pm-pack__perks');
    if (perks) perks.prepend(el('span', 'pm-chip pm-chip--coral', `Ahorras ${eur(i.save)}`));
  });

  // Ficha de un pack
  const price = document.querySelector('.product-details product-price, product-information product-price');
  if (here && price && !document.querySelector('.pm-pdp-save')) {
    const i = packInfo(here);
    if (i) {
      const line = was(i, 'pm-pdp-save');
      line.append(' · ');
      line.append(el('strong', '', `ahorras ${eur(i.save)}`));
      price.after(line);
    }
  }
};

// --- Ficha: las "Preguntas frecuentes" de la descripción repiten la sección del final ---
// (la descripción sale dos veces en el DOM, de ahí que se oculten todas).
const hideDuplicateFaq = () => {
  const hasFaq = !!document.querySelector('.pm-faq');
  // El bloque "Envío" de la descripción solo sobra si la ficha ya trae el desplegable "Envío y plazos".
  const hasShip = [...document.querySelectorAll('.pm-info summary')].some((x) => /^env[ií]o y plazos/i.test(x.textContent.trim()));
  if (!hasFaq && !hasShip) return;
  for (const h of document.querySelectorAll('h3')) {
    if (h.closest('.pm-faq') || h.hidden) continue;
    const t = h.textContent.trim();
    if (hasFaq && /^preguntas frecuentes/i.test(t)) {
      for (let n = h; n; n = n.nextElementSibling) n.hidden = true;
    } else if (hasShip && h.closest('.pm-info__body') && /^env[ií]o$/i.test(t)) {
      for (let n = h; n && (n === h || n.tagName !== 'H3'); n = n.nextElementSibling) n.hidden = true;
    }
  }
};

// Sin opiniones: fuera las estrellas grises; en los packs de ruidos, en su lugar, el regalo de la guía.
const hideEmptyStars = () => {
  document.querySelectorAll('.pm-stars').forEach((s) => {
    if (!/aún sin opiniones/i.test(s.textContent)) return;
    s.style.display = 'none';
    if (GUIDE_PACKS.includes(here) && !document.querySelector('.pm-guidebadge')) {
      s.after(el('p', 'pm-guidebadge', '🐾 Incluye guía PDF «Ruidos sin sustos» gratis'));
    }
  });
};

// --- Ficha con talla: consejo, ejemplos de raza (solo orejeras, que se eligen por peso) y garantía de cambio ---
const TIP = '💡 Consejo Patamora: mide el contorno del pecho justo detrás de las patas delanteras. Si tu peludo está entre dos tallas o tiene mucho pelo, elige siempre la talla superior para que se mueva cómodo.';
const EARS = 'Orejeras, por peso: S (hasta ~11 kg: ej. Teckel, Carlino, Bíchon, Jack Russell) · M (10-20 kg: ej. Bulldog francés, Beagle, Cocker, Border Collie) · L (+20 kg: ej. Labrador, Golden, Pastor alemán, Galgo, Mastín). Si tiene las orejas grandes para su tamaño, sube una talla.';
const TIP_MAT = '💡 Consejo Patamora: mide el sitio donde va (sofá, cama o rincón) y elige el tamaño que lo cubra. Si estás entre dos, elige el mayor.';
// El chaleco debe ir ceñido (no vale "la talla superior") y el vaso limpiapatas se elige por el tamaño de la pata, no del pecho.
const TIP_VEST = '💡 Consejo Patamora: mide el contorno del pecho justo detrás de las patas delanteras y compáralo con la tabla (el peso es orientativo). Debe quedar ceñido pero cómodo: que te quepan dos dedos bajo las cintas. Si dudas entre dos tallas, escríbenos con la medida y te ayudamos.';
const TIP_VASO = '💡 Consejo Patamora: elige el vaso según el tamaño de tu perro: pequeño (11 cm de alto), mediano (13,5 cm) o grande (15 cm). Si dudas, escríbenos y te ayudamos.';
const TIPS = { 'chaleco-calmante-perros': TIP_VEST, 'pack-calma-ruidos': TIP_VEST, 'vaso-limpiapatas': TIP_VASO };
// Cualquier opción llamada "Talla…" o "Tamaño…" lleva el aviso; otro nombre (p. ej. "Medida") hay que añadirlo aquí.
const sizeHelp = () => {
  if (!here) return;
  document.querySelectorAll('variant-picker fieldset:not([data-pm-h])').forEach((f) => {
    f.dataset.pmH = '1';
    const label = (f.querySelector('legend') || f).textContent;
    const mat = /tama[ñn]o/i.test(label);
    if (!mat && !/talla/i.test(label)) return;
    const box = el('details', 'pm-sizehelp');
    box.append(el('summary', '', mat ? '¿Dudas entre dos tamaños?' : '¿Dudas entre dos tallas?'));
    box.append(el('p', '', mat ? TIP_MAT : (TIPS[here] || TIP)));
    if (TIPS[here] === TIP_VEST && document.querySelector('.pm-howto')) {
      const how = el('a', 'pm-sizehelp__link', 'Ver cómo medir a mi perro');
      how.href = '#';
      how.addEventListener('click', (e) => { e.preventDefault(); document.querySelector('.pm-howto').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      box.append(how);
    }
    if (here === 'orejeras-para-perros' || here === 'pack-petardos') box.append(el('p', '', EARS));
    const guard = el('p', 'pm-sizeguard');
    guard.append('🛡️ ', el('strong', '', 'Compra sin miedo a fallar:'), mat ? ' si al llegar no encaja el tamaño, te ayudamos a cambiarlo fácil y rápido.' : ' si al llegar no le queda como un guante, te ayudamos a cambiar de talla fácil y rápido.');
    f.after(box);
    box.after(guard);
  });
};

// --- Entrega: hitos y mensaje según el producto (fecha límite real = plazo máximo) ---
const CALM = ['orejeras-para-perros', 'chaleco-calmante-perros', 'alfombrilla-olfativa-perros', 'pack-petardos', 'pack-calma-ruidos'];
const deliveryNote = () => {
  const box = document.querySelector('[data-pm-deliv]:not([data-pm-n])');
  if (!box) return;
  box.dataset.pmN = '1';
  const lines = [];
  const calm = CALM.includes(here);
  const latest = new Date();
  latest.setDate(latest.getDate() + (Number(box.dataset.arriveMax) || 32));
  const newYear = new Date(latest.getFullYear(), 11, 31, 23, 59);
  if (GUIDE_PACKS.includes(here)) lines.push('⚡ Hoy mismo: recibes la confirmación y la guía PDF por email con tu pedido.');
  if (calm && latest <= newYear) {
    const d = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long' }).format(latest);
    lines.push(`🎯 Justo a tiempo: si lo pides hoy llega, como muy tarde, el ${d} (plazo máximo), para ensayarlo antes de los petardos de diciembre y Nochevieja.`);
  } else if (!calm) {
    lines.push('Trabajamos bajo pedido, sin almacén propio: por eso el precio es más ajustado.');
  }
  const track = box.querySelector('.pm-deliv__track');
  if (track) lines.reverse().forEach((t) => track.after(el('p', 'pm-deliv__note', t)));
};

// --- Pie: el formulario promete el −10 %, así que lo dice y, al apuntarse, da el código ---
const footerSignup = () => {
  document.querySelectorAll('.email-signup__input:not([data-pm-p])').forEach((i) => {
    i.dataset.pmP = '1';
    i.placeholder = 'Tu email para enviarte el −10 %';
  });
  if (!/customer_posted=true/.test(location.search)) return;
  const ok = document.querySelector('[class*="email-signup__message--success"]:not([data-pm-c])');
  if (ok) {
    ok.dataset.pmC = '1';
    ok.append(el('strong', '', ' Tu código: BIENVENIDA10'));
  }
};

// --- Nombre del peludo (solo en el navegador) ---
const PET = 'pm_pet_name';
const petName = () => { try { return (localStorage.getItem(PET) || '').trim().slice(0, 20); } catch (e) { return ''; } };
const setPet = (v) => { try { if (v) localStorage.setItem(PET, v); else localStorage.removeItem(PET); } catch (e) { /* sin almacenamiento: no se guarda */ } };

const petForm = (done) => {
  const f = document.createElement('form');
  f.className = 'pm-petname__form';
  const i = el('input', '');
  i.placeholder = '¿Cómo se llama tu peludo?';
  i.maxLength = 20;
  i.setAttribute('aria-label', 'Nombre de tu peludo');
  const s = el('button', 'pm-petname__ok', 'Guardar');
  s.type = 'submit';
  f.append(i, s);
  f.onsubmit = (e) => {
    e.preventDefault();
    const v = i.value.trim().replace(/[<>]/g, '');
    if (v) { setPet(v); done(); }
  };
  return f;
};

const petUi = () => {
  const h = document.querySelector('.pm-cats .pm-h2');
  if (!h || h.dataset.pmP) return;
  h.dataset.pmP = '1';
  const base = h.textContent;
  const row = el('p', 'pm-petname');
  h.after(row);
  const render = () => {
    const n = petName();
    h.textContent = n ? `¿Qué necesita ${n} hoy?` : base;
    row.replaceChildren();
    if (n) {
      const b = el('button', 'pm-petname__x', '(x) Cambiar nombre');
      b.type = 'button';
      b.onclick = () => { setPet(''); render(); };
      row.append(b);
    } else {
      row.append(petForm(render));
    }
  };
  render();
};

// Ficha: bajo el selector, "Preparar el pedido para X" (o la invitación a poner el nombre)
const petLine = () => {
  const vp = document.querySelector('variant-picker:not([data-pm-pl])');
  if (!vp || !here) return;
  vp.dataset.pmPl = '1';
  const row = el('p', 'pm-petline');
  vp.after(row);
  const draw = () => {
    const n = petName();
    row.replaceChildren();
    if (n) {
      row.append(`Preparar el pedido para ${n} 🐾 `);
      const x = el('button', 'pm-petname__x', '(x)');
      x.type = 'button';
      x.setAttribute('aria-label', 'Cambiar nombre');
      x.onclick = () => { setPet(''); draw(); };
      row.append(x);
    } else {
      const b = el('button', 'pm-petname__x', '🐾 ¿Cómo se llama tu peludo? Personaliza tu experiencia');
      b.type = 'button';
      b.onclick = () => { row.replaceChildren(petForm(draw)); };
      row.append(b);
    }
  };
  draw();
};

// Carrito lateral: "La cesta de X" en la cabecera (solo se cambia el texto, no el contador)
const cartTitle = () => {
  const t = document.getElementById('cart-drawer-heading');
  if (!t) return;
  const tn = [...t.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
  if (!tn) return;
  if (!t.dataset.pmO) t.dataset.pmO = tn.textContent;
  const n = petName();
  const want = n ? `La cesta de ${n} ` : t.dataset.pmO;
  if (tn.textContent !== want) tn.textContent = want;
};

// --- Pata: en las fichas con talla, el aviso habla de la talla (y sale solo tras 40 s de dudas) ---
const nudgeText = () => (petName()
  ? `¿Dudas con la talla de ${petName()}? Dime cuánto pesa y su raza y te digo cuál elegir 🐾`
  : '¿Dudas entre dos tallas? Dime cuánto pesa tu peludo y qué raza es, ¡y te digo cuál elegir! 🐾');
const hasSizes = () => [...document.querySelectorAll('variant-picker legend')].some((e) => /talla/i.test(e.textContent));
const chatNudge = () => {
  const n = document.querySelector('[data-pm-chat-nudge]');
  if (!n || n.dataset.pmN || !here || !hasSizes()) return;
  n.dataset.pmN = '1';
  n.textContent = nudgeText();
  let changes = 0;
  let added = false;
  document.addEventListener('change', (e) => { if (e.target.closest('variant-picker')) changes += 1; });
  document.addEventListener('click', (e) => { if (e.target.closest('[data-pm-add], [name="add"], add-to-cart-component')) added = true; });
  setTimeout(() => {
    const panel = document.querySelector('[data-pm-chat]');
    if (added || !changes || (panel && !panel.hidden)) return;
    n.textContent = nudgeText();
    n.hidden = false;
    setTimeout(() => { n.hidden = true; }, 12000);
  }, 40000);
};

// --- "Así se usa": los pasos se iluminan solos de uno en uno cada 3,5 s (clic para elegir; quieto si prefiere menos movimiento) ---
const howto = () => {
  const ol = document.querySelector('.pm-howto__steps:not([data-pm-h])');
  if (!ol) return;
  ol.dataset.pmH = '1';
  const li = [...ol.children];
  if (li.length < 2) return;
  // Marco de la izquierda: escenas apiladas (o vídeo), barras tipo Story y etiqueta con el paso activo
  const media = ol.closest('.pm-howto')?.querySelector('.pm-howto__media');
  const slides = media ? [...media.querySelectorAll('[data-howto-slide]')] : [];
  const bars = media ? [...media.querySelectorAll('.pm-howto__bars i')] : [];
  const badge = media?.querySelector('[data-howto-badge]');
  const video = media?.querySelector('video');
  let i = 0;
  let timer = 0;
  const set = (n) => {
    i = n;
    li.forEach((x, k) => x.classList.toggle('is-active', k === n));
    slides.forEach((s, k) => s.classList.toggle('is-on', k === Math.min(n, slides.length - 1)));
    bars.forEach((b, k) => { b.classList.toggle('is-done', k < n); b.classList.toggle('is-on', k === n); });
    if (badge) badge.textContent = `${n + 1} · ${(li[n].querySelector('h3')?.textContent || '').trim()}`;
  };
  set(0);
  // Los pasos también se pueden elegir con el teclado
  li.forEach((x) => x.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); x.click(); } }));
  if (video) {
    // Con vídeo, los pasos siguen el vídeo por tercios y un clic salta a su tercio (sin temporizador de 3,5 s)
    const third = () => (Number.isFinite(video.duration) && video.duration > 0 ? video.duration / li.length : 0);
    video.addEventListener('timeupdate', () => {
      const t = third();
      const k = t ? Math.min(li.length - 1, Math.floor(video.currentTime / t)) : 0;
      if (t && k !== i) set(k);
    });
    li.forEach((x, k) => x.addEventListener('click', () => {
      const go = () => { video.currentTime = third() * k + 0.05; video.play().catch(() => {}); };
      set(k);
      if (third()) go(); else { video.addEventListener('loadedmetadata', go, { once: true }); video.preload = 'auto'; video.load(); }
    }));
    return;
  }
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const start = () => { clearInterval(timer); if (!still) timer = setInterval(() => set((i + 1) % li.length), 3500); };
  li.forEach((x, k) => x.addEventListener('click', () => { set(k); start(); }));
  if (still) return;
  new IntersectionObserver(([e]) => { if (e.isIntersecting) start(); else clearInterval(timer); }, { threshold: 0.3 }).observe(ol);
};

// --- Ficha: la barra fija de compra se aparta cuando llega el pie ---
const stickyVsFooter = () => {
  const f = document.querySelector('footer:not([data-pm-sf])');
  const bar = document.querySelector('.sticky-add-to-cart__bar');
  if (!f || !bar) return;
  f.dataset.pmSf = '1';
  new IntersectionObserver(([e]) => bar.classList.toggle('pm-sticky-hide', e.isIntersecting), { threshold: 0 }).observe(f);
};

// --- Catálogo (/collections/all): pestañas rápidas y orden de ventas en vez de alfabético ---
const ORDER = ['quitapelos-reutilizable', 'chubasquero-reflectante', 'vaso-limpiapatas', 'orejeras-para-perros', 'chaleco-calmante-perros', 'hamaca-ventana-gatos', 'pack-sin-pelos-total', 'pack-petardos', 'pack-calma-ruidos', 'pack-gato-feliz', 'pack-paseo', 'pack-casa-sin-pelos', 'pack-manos-libres', 'alfombrilla-olfativa-perros', 'alfombrilla-de-lamer', 'correa-manos-libres-perros', 'botella-de-paseo', 'cepillo-desenredante', 'guante-quitapelos', 'bolsa-de-premios', 'dispensador-de-bolsas'];
const TABS = [['Ver todo', '/collections/all'], ['🌧️ Lluvia y paseo', '/collections/paseos-con-lluvia'], ['⚡ Calma y petardos', '/collections/calma-para-perros'], ['✨ Sin pelos', '/collections/adios-pelos'], ['🐱 Gatos', '/collections/para-gatos'], ['📦 Solo packs', '/collections/packs']];
const catalog = () => {
  if (location.pathname !== '/collections/all') return;
  const first = document.querySelector('product-card');
  const grid = first && first.closest('li') && first.closest('li').parentElement;
  if (!grid) return;
  const count = String(grid.children.length);
  if (grid.dataset.pmO === count) return;
  grid.dataset.pmO = count;
  if (!document.querySelector('.pm-cattabs')) {
    const ul = el('ul', 'pm-cattabs');
    ul.setAttribute('aria-label', 'Categorías');
    TABS.forEach(([t, href], k) => {
      const li = document.createElement('li');
      const a = el('a', '', t);
      a.href = href;
      if (!k) a.setAttribute('aria-current', 'page');
      li.append(a);
      ul.append(li);
    });
    grid.before(ul);
  }
  if (/sort_by|filter\./.test(location.search)) return;
  // Sueltos primero (por ORDER, los nuevos detrás); los packs siempre al final: quien los busca tiene la pestaña "Solo packs".
  const rank = (item) => {
    const h = handleOf(item.querySelector('a.product-card__link')) || '';
    const k = ORDER.indexOf(h);
    return (h.startsWith('pack-') ? 1000 : 0) + (k < 0 ? 99 : k);
  };
  [...grid.children].filter((x) => x.querySelector('product-card')).sort((a, b) => rank(a) - rank(b)).forEach((x) => grid.append(x));
};

// --- Ficha: comparación honesta con el pack, bajo el botón de compra. Solo productos con precio único y un pack de precio único;
// el envío de 3,95 € se suma al producto suelto si no llega a 30 € (el pack lo lleva gratis). Se calcula con los precios de pm-data. ---
const PACK_UPSELL = { 'quitapelos-reutilizable': 'pack-casa-sin-pelos', 'botella-de-paseo': 'pack-paseo', 'correa-manos-libres-perros': 'pack-manos-libres' };
const WITH_ART = { 'guante-quitapelos': 'el guante quitapelos', 'dispensador-de-bolsas': 'el dispensador de bolsas', 'bolsa-de-premios': 'la bolsa de premios' };
const packNudge = () => {
  const me = data && data.p[here];
  const pack = data && data.p[PACK_UPSELL[here]];
  const block = document.querySelector('.buy-buttons-block:not([data-pm-pn])');
  if (!me || !pack || !pack.k || !block) return;
  block.dataset.pmPn = '1';
  const diff = pack.c - (me.c + (me.c < 3000 ? 395 : 0));
  if (diff <= 0) return;
  const others = pack.k.filter((k) => k !== here && data.p[k]).map((k) => WITH_ART[k] || short(data.p[k].t).toLowerCase());
  const box = el('div', 'pm-packnudge');
  box.append(el('p', 'pm-packnudge__t', `¿Te llevas también ${others.join(' y ')}? Por ${eur(diff)} más sobre tu pedido con envío, llévate el ${pack.t}.`));
  box.append(el('p', 'pm-packnudge__s', `${pack.k.map((k) => short(data.p[k].t)).join(' + ')} por ${eur(pack.c)}, con envío gratis.`));
  const a = el('a', 'pm-packnudge__a', `Ver el pack con ${others.join(' y ')}`);
  a.href = pack.u;
  box.append(a);
  block.after(box);
};

// --- Contacto: la tarjeta del pedido abre Pata en el seguimiento; devoluciones dice "lo reponemos gratis" ---
const contactPatch = () => {
  const quick = document.querySelector('.pm-contact__quick:not([data-pm-c])');
  if (!quick) return;
  quick.dataset.pmC = '1';
  const [order, , returns] = quick.children;
  const b = el('button', 'pm-btn pm-btn--ghost', 'Preguntar a Pata por mi pedido');
  b.type = 'button';
  b.dataset.pmTrackChat = '1';
  order.append(b);
  const p = returns.querySelector('p');
  if (p) p.textContent = 'Tienes 14 días desde que lo recibes. Si algo llega defectuoso o roto, lo reponemos gratis.';
};
document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-pm-track-chat]')) return;
  document.querySelector('.pm-chat__fab')?.click();
  setTimeout(() => document.querySelector('.pm-chat__chips [data-ask="seguimiento"]')?.click(), 500);
});

// --- Artículo de cepillado: sin cambios aquí (la calculadora va en pm-article) ---

const run = () => {
  heroTrust();
  decoratePacks();
  hideDuplicateFaq();
  hideEmptyStars();
  sizeHelp();
  deliveryNote();
  footerSignup();
  petUi();
  petLine();
  cartTitle();
  chatNudge();
  howto();
  stickyVsFooter();
  catalog();
  packNudge();
  contactPatch();
};

let timer;
new MutationObserver(() => {
  clearTimeout(timer);
  timer = setTimeout(run, 150);
}).observe(document.documentElement, { childList: true, subtree: true });
run();

// --- Pestaña: con el carrito lleno y la pestaña en segundo plano, el título alterna con un recordatorio ---
const baseTitle = document.title;
let tabTimer = 0;
document.addEventListener('visibilitychange', async () => {
  clearInterval(tabTimer);
  if (!document.hidden) { document.title = baseTitle; return; }
  const n = await cartCount();
  if (!n || !document.hidden) return;
  let alt = false;
  tabTimer = setInterval(() => {
    document.title = alt ? baseTitle : `🐾 (${n}) ¡Tu peludo te espera en el carrito! — Patamora`;
    alt = !alt;
  }, 2500);
});

// --- Salvavidas de carrito (una vez por sesión, solo con la cesta llena): escritorio, al sacar el ratón por arriba; móvil, tras 45 s sin tocar nada ---
const exitSeen = () => { try { return sessionStorage.getItem('pm_exit'); } catch (e) { return '1'; } };
const showExit = async () => {
  if (exitSeen() || location.pathname.startsWith('/checkout') || document.querySelector('dialog[open]')) return;
  try { sessionStorage.setItem('pm_exit', '1'); } catch (err) { return; }
  if (!(await cartCount())) return;
  const tpl = document.getElementById('pm-exit-tpl');
  if (!tpl) return;
  const dlg = tpl.content.firstElementChild.cloneNode(true);
  document.body.append(dlg);
  dlg.querySelectorAll('[data-pm-exit-close]').forEach((b) => b.addEventListener('click', () => dlg.close()));
  dlg.addEventListener('close', () => dlg.remove());
  dlg.showModal();
};
const t0 = Date.now();
if (matchMedia('(hover: hover)').matches) {
  document.addEventListener('mouseout', (e) => {
    if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 10000) showExit();
  });
} else {
  let idle = 0;
  const arm = () => { clearTimeout(idle); idle = setTimeout(showExit, 45000); };
  ['touchstart', 'scroll'].forEach((ev) => addEventListener(ev, arm, { passive: true }));
  arm();
}
